import { ActionType } from 'flow/store/engine/constants';

export const BEST_EFFORT_PARSING_DEFAULT_STRING = null;
export const BEST_EFFORT_PARSING_PLACEHOLDER_STRING = 'enter_string';
export const BEST_EFFORT_PARSING_PLACEHOLDER_MULTISELECT = 'make_selection';
export const PLACEHOLDER_STRING = '...';

export const supportedNullActionTypes = new Set([
  ActionType.INPUT,
  ActionType.SERVICE,
]);

export const invalidLeftSideDynamicComparisonTypes = new Set([
  ActionType.MATRIX_MODEL,
  ActionType.TAG,
  ActionType.OUTCOME_REASON,
  ActionType.OUTPUT,
]);

export const minMaxLimitRequiredActionTypes = new Set([
  ActionType.OUTPUT,
  ActionType.IMPORTED_OUTPUT_ATTRIBUTE,
  ActionType.IMPORTED_MATRIX_MODEL,
  ActionType.INPUT,
  ActionType.MATRIX_MODEL,
]);
